export default class EarlyAlertReason {
}
